import { fromJS } from 'immutable';
import {
  ATTACK,
  ATTACK_END,
} from './constants';
import { APP_RESET } from '../App/constants';

const initialState = fromJS({
  attacking: false,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case ATTACK:
      return state.set('attacking', true);

    case ATTACK_END:
      return state.set('attacking', false);

    case APP_RESET:
      return initialState;

    default:
      return state;
  }
}

export default reducer;
